<template>
    <b-modal ref="modal" v-bind="$attrs" :id="id" title-class="font-18" centered hide-footer size="lg">
        <template #modal-header-close>
            <div>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="#30345B" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M10 0C4.47 0 0 4.47 0 10C0 15.53 4.47 20 10 20C15.53 20 20 15.53 20 10C20 4.47 15.53 0 10 0ZM14.3 14.3C14.2075 14.3927 14.0976 14.4663 13.9766 14.5164C13.8557 14.5666 13.726 14.5924 13.595 14.5924C13.464 14.5924 13.3343 14.5666 13.2134 14.5164C13.0924 14.4663 12.9825 14.3927 12.89 14.3L10 11.41L7.11 14.3C6.92302 14.487 6.66943 14.592 6.405 14.592C6.14057 14.592 5.88698 14.487 5.7 14.3C5.51302 14.113 5.40798 13.8594 5.40798 13.595C5.40798 13.4641 5.43377 13.3344 5.48387 13.2135C5.53398 13.0925 5.60742 12.9826 5.7 12.89L8.59 10L5.7 7.11C5.51302 6.92302 5.40798 6.66943 5.40798 6.405C5.40798 6.14057 5.51302 5.88698 5.7 5.7C5.88698 5.51302 6.14057 5.40798 6.405 5.40798C6.66943 5.40798 6.92302 5.51302 7.11 5.7L10 8.59L12.89 5.7C12.9826 5.60742 13.0925 5.53398 13.2135 5.48387C13.3344 5.43377 13.4641 5.40798 13.595 5.40798C13.7259 5.40798 13.8556 5.43377 13.9765 5.48387C14.0975 5.53398 14.2074 5.60742 14.3 5.7C14.3926 5.79258 14.466 5.90249 14.5161 6.02346C14.5662 6.14442 14.592 6.27407 14.592 6.405C14.592 6.53593 14.5662 6.66558 14.5161 6.78654C14.466 6.90751 14.3926 7.01742 14.3 7.11L11.41 10L14.3 12.89C14.68 13.27 14.68 13.91 14.3 14.3Z"
                        fill="#30345B" />
                </svg>
            </div>
        </template>
        <template #modal-header>
        </template>
        <div v-if="preview && format" class="relative">
            <div v-if="['application/pdf', 'pdf'].includes(format)" class="position-relative pdf-preview">
                <button class="btn btn-link" @click="openPreview" target="_blank">{{ $t("See Detail") }}</button>
                <object class="mt-1" :data="preview" type="application/pdf" width="100%" height="500px">
                </object>
                <div class="button-close" v-if="deletable" @click="$event => $emit('delete')">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M15 11H5V9H15M10 0C8.68678 0 7.38642 0.258658 6.17317 0.761205C4.95991 1.26375 3.85752 2.00035 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C3.85752 17.9997 4.95991 18.7362 6.17317 19.2388C7.38642 19.7413 8.68678 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0Z"
                            fill="#DC1021" />
                    </svg>
                </div>
            </div>
            <div class="relative" v-else>
                <b-img thumbnail fluid style="height: 100%; width: 100%; object-fit: contain;" :src="preview">
                </b-img>
                <div class="button-close" v-if="deletable" @click="$event => $emit('delete')">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M15 11H5V9H15M10 0C8.68678 0 7.38642 0.258658 6.17317 0.761205C4.95991 1.26375 3.85752 2.00035 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C3.85752 17.9997 4.95991 18.7362 6.17317 19.2388C7.38642 19.7413 8.68678 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0Z"
                            fill="#DC1021" />
                    </svg>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>

export default {
    name: 'ImagePreviewModal',
    props: {
        id: {
            type: String,
            default: 'image-preview-modal'
        },
        preview: String,
        format: String,
        deletable: Boolean,
    },
    data() {
        return {
        }
    },
}
</script>

<style scoped lang="scss">
::v-deep {
    .close {
        opacity: 1 !important;
    }

    .modal-header {
        border: none !important;
    }
}
</style>